import { CircularProgress } from '@shared/components';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { PluginLandingPage } from '@shared/generated/graphql';
import {
  ACTIVITY_ROUTE,
  CHATS_ROUTE,
} from 'clerk_common/constants/urls/routes';
import { Navigate } from 'react-router-dom';
import { useIsChatsLandingAvailable } from './useIsChatsLandingAvailable';

export function PluginLandingRedirect() {
  const { me } = useMeContext();
  const { isAvailable: isChatsLandingAvailable, loading } =
    useIsChatsLandingAvailable();

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  const prefersActivity =
    me?.settings?.pluginLandingPage === PluginLandingPage.ACTIVITY;
  const shouldLandOnChats = isChatsLandingAvailable && !prefersActivity;
  return (
    <Navigate to={shouldLandOnChats ? CHATS_ROUTE : ACTIVITY_ROUTE} replace />
  );
}
